export default "__VITE_ASSET__Boo_kIji__"